module.exports = __webpack_public_path__ + "resources/img/main05_m.30993e47d0b829f56e7d891994123740.png";